import Button from '@components/formControls/Button'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

export const Title = styled(Typography)`
  line-height: 28px;
  letter-spacing: 0;
`

export const SearchString = styled(Typography)`
  letter-spacing: 0;
`
export const SaveSearchBtn = styled(Button)`
  padding: 6px 13px 7px 13px;
  min-height: unset;
`
export const SavedSearchContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`
